(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-announcement-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.getElementById('b2bAnnouncementBar');
    const closeButton = announcementBar?.querySelector('.b2b-announcement-bar__close');
    
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        announcementBar.style.transform = 'translateY(-100%)';
        announcementBar.style.opacity = '0';
        setTimeout(() => {
          announcementBar.style.display = 'none';
        }, 300);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b2b-popup-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('b2bPopupModal');
    const closeButton = modal?.querySelector('.b2b-popup-modal__close');
    const backdrop = modal?.querySelector('.b2b-popup-modal__backdrop');
    
    if (!modal) return;
    
    // Cookie management
    function setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }
    
    function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    
    // Check if modal should be shown (every 24 hours)
    function shouldShowModal() {
      const lastShown = getCookie('kosmosq_b2b_popup_shown');
      if (!lastShown) return true;
      
      const lastShownTime = parseInt(lastShown);
      const now = Date.now();
      const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      
      return (now - lastShownTime) > twentyFourHours;
    }
    
    // Show modal
    function showModal() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setCookie('kosmosq_b2b_popup_shown', Date.now().toString(), 30); // Cookie expires in 30 days
    }
    
    // Hide modal
    function hideModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    // Event listeners
    if (closeButton) {
      closeButton.addEventListener('click', hideModal);
    }
    
    if (backdrop) {
      backdrop.addEventListener('click', hideModal);
    }
    
    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        hideModal();
      }
    });
    
    // Show modal after delay if conditions are met
    if (shouldShowModal()) {
      setTimeout(() => {
        showModal();
      }, 3000); // Show after 3 seconds
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast-announcement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var toasts = document.querySelectorAll('[data-toast-announcement]');

    toasts.forEach(function(toast) {
      var toastId = toast.getAttribute('data-toast-announcement-id') || 'default';
      var storageKey = 'kosmosq_toast_announcement_dismissed_' + toastId;
      var closeButton = toast.querySelector('[data-toast-announcement-close]');
      var isDismissed = false;

      try {
        isDismissed = window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        isDismissed = false;
      }

      if (isDismissed) {
        return;
      }

      toast.hidden = false;
      window.requestAnimationFrame(function() {
        toast.classList.add('toast-announcement--visible');
      });

      if (!closeButton) {
        return;
      }

      closeButton.addEventListener('click', function() {
        try {
          window.localStorage.setItem(storageKey, 'true');
        } catch (error) {}

        toast.classList.remove('toast-announcement--visible');
        window.setTimeout(function() {
          toast.hidden = true;
        }, 180);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
